var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg1Star = function Svg1Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -479,
    y: -107,
    display: "inline",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 1428,
    height: 1012
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,56.158c-12.798,0-23.211,8.287-23.211,18.474c0,1.308,1.06,2.368,2.368,2.368c1.308,0,2.368-1.06,2.368-2.368   c0-7.574,8.287-13.737,18.474-13.737s18.474,6.163,18.474,13.737c0,1.308,1.06,2.368,2.368,2.368s2.368-1.06,2.368-2.368   C73.211,64.445,62.798,56.158,50,56.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.913,47.158c4.278,0,7.758-3.48,7.758-7.758c0-1.308-1.06-2.368-2.368-2.368c-1.308,0-2.368,1.06-2.368,2.368v0   c0,1.666-1.355,3.021-3.021,3.021c-1.666,0-3.021-1.355-3.021-3.021v0c0-1.308-1.06-2.368-2.368-2.368s-2.368,1.06-2.368,2.368   C26.155,43.678,29.635,47.158,33.913,47.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.476,37.032c-1.308,0-2.368,1.06-2.368,2.368v0c0,1.666-1.355,3.021-3.021,3.021c-1.666,0-3.021-1.355-3.021-3.021v0   c0-1.308-1.06-2.368-2.368-2.368c-1.308,0-2.368,1.06-2.368,2.368c0,4.278,3.48,7.758,7.758,7.758c4.277,0,7.757-3.48,7.757-7.758   C73.844,38.092,72.784,37.032,71.476,37.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,5C25.187,5,5,25.187,5,50s20.187,45,45,45s45-20.187,45-45S74.813,5,50,5z M50,90.263   C27.799,90.263,9.737,72.201,9.737,50S27.799,9.737,50,9.737S90.263,27.799,90.263,50S72.201,90.263,50,90.263z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1star.ecc8e149.svg";
export { ForwardRef as ReactComponent };